import styled from "styled-components";
import { Card } from "react-bootstrap";

import { recommendedImage } from "assets/images";

export const RecommendCardContainer = styled(Card)`
  border-radius: 23px;
  padding: 18px 7px;
  text-align: center;
  background-image: url("${recommendedImage}");
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  position: relative;
  color: #ffffff;
  border: 0;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;
  }

  h2 {
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  p {
    font-size: 20px;
    font-weight: 500;
  }

  .button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;

    .btn-find {
      background-color: #ffffff;
      color: #036fc7;
      position: absolute;
      bottom: 15px;
      width: calc(100% - 14px);
      font-size: 14px;
      font-weight: 500;
      line-height: normal;

      &:hover {
        background-color: #ffffff;
      }
    }
  }

  @media (max-width: 767px) {
    min-height: 265px;

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 363px) {
    min-height: 315px;
  }

  @media screen and (max-width: 1100px) {
    .button-wrapper .btn-find {
      height: auto;
    }
  }
`;
